import React, { useState, useEffect } from 'react';
import api from '../api';

export default function Clients() {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name:'', industry:'', contact_name:'', email:'', phone:'', budget:'' });
  const [saving, setSaving] = useState(false);

  useEffect(() => { load(); }, []);
  const load = async () => {
    try { const r = await api.get('/clients'); setClients(r.data.data); }
    catch {} finally { setLoading(false); }
  };

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.post('/master/clients', { ...form, budget: parseFloat(form.budget) || 0 });
      setShowForm(false);
      setForm({ name:'', industry:'', contact_name:'', email:'', phone:'', budget:'' });
      load();
    } catch {} finally { setSaving(false); }
  };

  if (loading) return <div className="page-wrap"><div className="empty-state"><div className="empty-state-title">Loading...</div></div></div>;

  return (
    <div className="page-wrap">
      <div style={{ display:'flex', justifyContent:'flex-end', marginBottom: 16 }}>
        <button className="btn btn-primary" onClick={() => setShowForm(true)}>+ Add Client</button>
      </div>

      <div className="grid-3">
        {clients.map(c => (
          <div key={c.id} className="card">
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '14px' }}>
              <div className="avatar avatar-lg" style={{ background: c.color || 'var(--accent)', borderRadius: '10px', fontSize: '1.1rem' }}>{c.name.charAt(0)}</div>
              <div>
                <div className="fw-700" style={{ color: 'var(--text)', fontSize: '0.95rem' }}>{c.name}</div>
                <div className="text-xs text-muted">{c.industry || 'No industry'}</div>
              </div>
              <div style={{ marginLeft: 'auto' }}>
                <span className={`badge ${c.is_active ? 'badge-green' : 'badge-gray'}`}>{c.is_active ? 'Active' : 'Inactive'}</span>
              </div>
            </div>
            <div className="sep" />
            {c.contact_name && <div className="text-sm" style={{ margin: '6px 0' }}>👤 {c.contact_name}</div>}
            {c.email && <div className="text-sm text-muted" style={{ margin: '4px 0' }}>✉️ {c.email}</div>}
            {c.phone && <div className="text-sm text-muted" style={{ margin: '4px 0' }}>📞 {c.phone}</div>}
            {c.budget > 0 && (
              <div style={{ marginTop: '10px' }}>
                <div className="flex-between mb-8">
                  <span className="text-xs text-muted">Monthly Budget</span>
                  <span className="text-xs mono fw-700">₹{Number(c.budget).toLocaleString('en-IN')}</span>
                </div>
              </div>
            )}
          </div>
        ))}
        {clients.length === 0 && (
          <div className="empty-state" style={{ gridColumn: '1/-1' }}>
            <div className="empty-state-icon">🏢</div>
            <div className="empty-state-title">No clients yet</div>
            <div className="text-sm text-muted">Click "+ Add Client" to add your first client.</div>
          </div>
        )}
      </div>

      {showForm && (
        <div className="modal-overlay">
          <div className="modal-box">
            <div className="modal-header">
              <div className="modal-title">+ Add Client</div>
              <button className="modal-close" onClick={() => setShowForm(false)}>✕</button>
            </div>
            <div className="modal-body">
              <form onSubmit={save}>
                <div className="form-row">
                  <div className="form-group"><label className="form-label">Client Name *</label><input className="form-input" value={form.name} onChange={e => setForm({...form, name: e.target.value})} required /></div>
                  <div className="form-group"><label className="form-label">Industry</label><input className="form-input" value={form.industry} onChange={e => setForm({...form, industry: e.target.value})} placeholder="Manufacturing" /></div>
                </div>
                <div className="form-row">
                  <div className="form-group"><label className="form-label">Contact Person</label><input className="form-input" value={form.contact_name} onChange={e => setForm({...form, contact_name: e.target.value})} /></div>
                  <div className="form-group"><label className="form-label">Email</label><input className="form-input" type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} /></div>
                </div>
                <div className="form-row">
                  <div className="form-group"><label className="form-label">Phone</label><input className="form-input" value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} /></div>
                  <div className="form-group"><label className="form-label">Monthly Budget (₹)</label><input className="form-input" type="number" value={form.budget} onChange={e => setForm({...form, budget: e.target.value})} /></div>
                </div>
                <div className="modal-footer" style={{ padding: '0', border: 'none', marginTop: '8px' }}>
                  <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>Cancel</button>
                  <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? 'Saving...' : 'Add Client'}</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
